export const app_language_enum = [
  'tr',
  'en',
];
